/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  arMfgFldData,
  arMfgTblData,
  getUnallocatedMfgAr,
} from '../../ARManufacturer/store/actions';
import {
  ndcDetailSingle,
  singleAccRecNDCDetail,
} from '../../AccRecNDCDetail/store/actions';
import {
  allAccRecNDCDetail,
  ndcDetail,
} from '../../AccRecNDCDetailAll/store/actions';
import { clearReqAccRecSearchPageDispatch } from '../../ReqAccReceivable/store/actions';
import {
  commonSearchPageOther,
  commonSearchPage,
} from '../../AccountsRevConstants';

export const manufacturerArTbl = (val) => {
  return { type: actiontypes.MANU_AR_TBL_DATA, payload: val };
};

export const fldValueUpdate = (val) => {
  return { type: actiontypes.MANU_AR_FLD_DATA, payload: val };
};

export const mfgARFirstLoad = (val) => {
  return { type: actiontypes.MFG_AR_FIRST_LOAD, payload: val };
};

export const showSelectAction = (val) => {
  return { type: actiontypes.MANU_AR_SHOW_SELECT, payload: val };
};

export const getUnallocatedMfg = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_UNALLOCATED_BAL_MFG}`, val)
    .then((response) => {
      let unAllcatedData = {
        [`${val?.mfgId}-${val?.rebateProgram ? val?.rebateProgram : 'All'}`]:
          response.data.unallocatedBalance,
      };
      dispatch({
        type: actiontypes.MANU_AR_UNALLOCATED_VAL,
        payload: unAllcatedData,
      });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.MANU_AR_UNALLOCATED_VAL, payload: null })
    );
};

export const getManuARForSglRpc = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_MFG_SINGLE_SIGNLE}`, val)
    .then((response) => {
      dispatch({ type: actiontypes.AR_MANU_NAV_DATA, payload: response.data });
      dispatch(
        arMfgTblData(
          response.data.accountReceivableDetailSforSingleMfgGridResponseVOs
        )
      );
      dispatch(arMfgFldData(data));
      let payload = {
        planType: data.planType,
        mfgId: data.mfgId,
        rebateProgram: data.rebateProgram,
        startQtr: data.startQtr,
        endQtr: data.endQtr,
        useOfficialURA: data.useOfficialURA,
        allRebateProgIndicator: 0,
      };
      dispatch(getUnallocatedMfgAr(payload));
    })
    .catch((response) => dispatch(manufacturerArTbl({})));
};

export const getAccRecNDCSingleData = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_NDC_SGL_RPC}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.NDC_DETAIL_SIGNLE_MFG,
        payload: response.data,
      });
      let accRecNDCDetailData = {
        [val.rebateProgramCd]: response.data,
      };
      dispatch(ndcDetailSingle(data));
      dispatch(singleAccRecNDCDetail(accRecNDCDetailData));
      return response.data;
    })
    .catch(() => {
      dispatch({ type: actiontypes.NDC_DETAIL_SIGNLE_MFG, payload: null });
    });
};

export const getAccRecNDCAllData = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_NDC_ALL_RPC}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.NDC_DETAIL_ALL_MFG,
        payload: response.data,
      });
      dispatch(allAccRecNDCDetail(response.data));
      dispatch(ndcDetail(data));
    })
    .catch(() => {
      dispatch({ type: actiontypes.NDC_DETAIL_ALL_MFG, payload: null });
      // dispatch(allAccRecNDCDetail([]));
    });
};

export const dispatchClearReduxData = () => (dispatch) => {
  dispatch(manufacturerArTbl({}));
  dispatch(fldValueUpdate(''));
  dispatch(mfgARFirstLoad([]));
  dispatch(showSelectAction([]));
  dispatch(getUnallocatedMfg({}));
  dispatch(getManuARForSglRpc([]));
  dispatch(getAccRecNDCSingleData([]));
  dispatch(getAccRecNDCAllData([]));
};

// export const dispatchClearReduxData = (val) => {
//   return { type: actiontypes.MFG_ACCOUNT_REC_CLEAR_REDUX };
// };

export const clearMfgAccountRecPage = (history) => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.AccountRecReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass = false;
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) => x.navTo === '/reqAccReceivable' || x.navTo === '/ARManufacturer'
      ).length === 0
    ) {
      newObj.rbt_list = [];
      changePass = true;
    }
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/reqAccReceivable' ||
          x.navTo === '/QtrAccountsRecAll' ||
          x.navTo === '/arSummaryByQtrAll' ||
          x.navTo === '/ARSummaryByQtrAll'
      ).length === 0
    ) {
      newObj.rebate_list = [];
    }
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/reqAccReceivable' ||
          x.navTo === '/arSummaryByQtrAll' ||
          x.navTo === '/ARSummaryByQtrAll'
      ).length === 0
    ) {
      newObj.rebate_pgm = 'MDFD';
      newObj.qtr_opt = 'All';
      newObj.end_qtr = '';
      newObj.start_qtr = '';
      newObj.ar_smry_qtr = null;
      changePass = true;
    }
    newObj1 = _.cloneDeep(newObj);
  } else {
    _.mapKeys({ ...commonSearchPageOther, ...commonSearchPage }, (val, key) => {
      newObj1[key] = val;
    });

    changePass = true;
  }
  if (changePass) {
    dispatch(clearReqAccRecSearchPageDispatch(newObj1));
  }
  dispatch(dispatchClearReduxData());
};
